
import {Component, OnInit , AfterViewInit , ElementRef, ViewChild} from '@angular/core';
import { SouscripteurService } from '../services/souscripteur.service';
import { Souscripteur } from '../models/souscripteur.model';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CheckTokenService } from '../../common/services/check-token.service';
import { CheckProfileService } from '../../common/services/check-profile.service';
import { AuthorizationService } from '../../common/services/authorization.service';


@Component({
  selector: 'app-souscripteur',
  templateUrl: './souscripteur.component.html',
  styleUrls: ['./souscripteur.component.css']
})


export class SouscripteurComponent implements OnInit {


    //length = 10000;
    pageSize = 10;
    pageSizeOptions = [10, 20, 50, 100];
    httpOptions = {headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    displayedColumns = ['id', 'nom', 'tel', 'codeWeb', 'codeMobile'];
    dataSource = new  MatTableDataSource<Souscripteur>();

    /*@ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort*/

    isData = false;   

    constructor(private authorizationService: AuthorizationService, private checkTokenService: CheckTokenService, private checkProfileService: CheckProfileService, private souscripteurService: SouscripteurService) { 
      
     this.authorizationService.isClient();

      
    }

    ngOnInit() {
      this.checkTokenService.verifyToken();
     this.souscripteurService.getSouscripteur().subscribe(
          data => {
              this.dataSource.data = data;
              //this.dataSource.paginator = this.paginator;
              //this.dataSource.sort = this.sort;
              this.isData = true;
          });

         

       

    }

    private paginator: MatPaginator;
    private sort: MatSort;
  
    @ViewChild(MatSort) set matSort(ms: MatSort) {
      this.sort = ms;
      this.setDataSourceAttributes();
    }
  
    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
      this.paginator = mp;
      this.setDataSourceAttributes();
    }
  
    setDataSourceAttributes() {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      //this.dataSource.filterPredicate = (data: Souscripteur , filter: string) => (data.id.indexOf(filter) != -1 || data.firstName.indexOf(filter) != -1 || data.lastName.indexOf(filter) != -1 || data.compagny.indexOf(filter) != -1);
  
      /*if (this.paginator && this.sort) {
        this.applyFilter('');
      }*/
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }


}




// WEBPACK FOOTER //
// ./src/app/admin-app/souscripteurs/souscripteur.component.ts